import { ECOSYSTEM } from "@/data/content";

export default function Marquee() {
  const items = [...ECOSYSTEM, "Solar EPC", "BOS Supply", "Net Metering", "Energy Independence"];
  const row = [...items, ...items];
  return (
    <div className="py-6 border-y border-white/10 bg-[#04261C]/40 overflow-hidden" aria-hidden="true">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-6 px-6 font-display text-2xl sm:text-4xl font-extrabold text-white/15">
            {t} <span className="text-emerald-500/50 text-xl">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
